export default "__VITE_ASSET__8df2621c__"